import React, { useState } from 'react';
import clsx from 'clsx';
import {
  Drawer,
  AppBar,
  Toolbar,
  List,
  CssBaseline,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputLabel,
  Chip,
  Button,
  Container,
  Collapse,
} from '@material-ui/core';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import ContactPhoneOutlinedIcon from '@material-ui/icons/ContactPhoneOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import Filter7OutlinedIcon from '@material-ui/icons/Filter7Outlined';
import EventBusyOutlinedIcon from '@material-ui/icons/EventBusyOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PlaylistAddCheckOutlinedIcon from '@material-ui/icons/PlaylistAddCheckOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import EventNoteIcon from '@material-ui/icons/EventNote';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { useStyles } from './sideNavStyles';
import { Link, Route } from 'react-router-dom';
import { deleteCookie } from '../../../redux/utils/customMethods';
import { logoutUser } from '../../../redux/users/usersActions';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../../assets/SciataLogo.png';

import ProjectsManage from '../../admin/projectsManage/ProjectsManage';
import ProjectDetails from '../../admin/projectsManage/components/ProjectDetails';
import TimesheetApproval from '../../admin/timesheetApproval/TimesheetApproval';
import TimesheetSummary from '../../admin/timesheetSummary/TimesheetSummary';
import SummaryByDay from '../../admin/timesheetSummary/components/summaryByDay/SummaryByDay';
import TimesheetUsers from '../../admin/timesheetUsers/TimesheetUsers';
import TimesheetExternalUsers from '../../admin/externalUsers/TimesheetUsers';
import TimesheetUserDetails from '../../admin/timesheetUsers/components/TimesheetUserDetails';
import TimesheetExternalUserDetails from '../../admin/externalUsers/components/TimesheetUserDetails';
import TimesheetDefaulters from '../../admin/timesheetDefaulters/TimesheetDefaulters';
import TimesheetVacationHours from '../../admin/timesheetVacationHours/components/TimesheetVacationHours';
import VacationHours from '../../admin/timesheetVacationHours/VacationHours';
import BillingReport from '../../admin/billingReport/BillingReport';
import Billing from '../../admin/billing/Billing';
import VendorReport from '../../admin/vendors/Vendors';
import VendorDetails from '../../admin/vendors/components/VendorDetails';
import PtoRequestReview from '../../admin/ptoRequestReview/PtoRequestReview';
import PtoRequestReport from '../../admin/ptoRequestReport/PtoRequestReview';
import PtoRequest from '../../user/ptoRequest/PtoRequest';
import Timesheet from '../../user/timesheet/Timesheet';
import UserReports from '../../user/userReports/UserReports';
import ProfilePage from '../../user/profile/ProfilePage';
import UnauthPage from '../../UnauthPage/UnathPage';
import { PrivateRoute } from '../../privateRoute/privateRoute';
import invoiceReport from '../../admin/invoiceReport';
import TaskReport from '../../admin/taskReport';
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import InboxIcon from "@material-ui/icons/MoveToInbox";

const cookieName = 'user_token';

const SideNav = props => {
  const {
    sideNavText,
    icons,
    sideNavLink,
    divider,
    drawerClose,
    drawer,
    drawerOpen,
    chip,
    hide,
    menuButton,
    header,
    appBarShift,
    appBar,
    root,
    toolbar,
    chipLabel,
    closeIcon,
    logoutButton,
    content,
    subHeader,
  } = useStyles();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  const user = useSelector(state => state.users.currentUser);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  
  const [openPanel, setOpenPanel] = React.useState(false);
  const [openSecondLevel, setOpenSecondLevel] = React.useState(true);
  const handleClick = () => {
    setOpenPanel(!openPanel);
  };

  const handleClickSecondLevel = () => {
    setOpenSecondLevel(!openSecondLevel);
  };
  const handleLogout = async () => {
    deleteCookie(cookieName);
    deleteCookie('access_token');
    deleteCookie('refresh_token');
    await dispatch(logoutUser());
    props.history.push('/');
  };

  const renderAdminList = () => {
    return (
      <>
        {open ? <h4 className={subHeader}>ADMIN</h4> : null}
        <List>
        {[
            'admin/approvals',
            'admin/summaries',
            'admin/summariesbyday',
            'admin/defaulters',
            'admin/users',
            'admin/externalUsers',  
            'admin/vacationHoursList',
            'admin/projects',
            'admin/billing',
            'admin/vendors',
            'admin/pto-request-review'
          ].map(text => (
            <Link className={sideNavLink} to={`/${text}`}>
              <ListItem button key={text}>
                {text === 'admin/approvals' && (
                  <>
                    <ListItemIcon className={icons}>
                      <PlaylistAddCheckOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Approvals</ListItemText>
                  </>
                )}
                {text === 'admin/summaries' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries</ListItemText>
                  </>
                )}
                {text === 'admin/summariesbyday' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries By Day</ListItemText>
                  </>
                )}
                {text === 'admin/defaulters' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventBusyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Defaulters</ListItemText>
                  </>
                )}
                {text === 'admin/users' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Users</ListItemText>
                  </>
                )}
                 {text === 'admin/externalUsers' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>External Users</ListItemText>
                  </>
                )}
                {text === 'admin/vacationHoursList' && (
                  <>
                    <ListItemIcon className={icons}>
                      <Filter7OutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Vacation Hours</ListItemText>
                  </>
                )}
                {text === 'admin/projects' && (
                  <>
                    <ListItemIcon className={icons}>
                      <WorkOutlineOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Projects</ListItemText>
                  </>
                )}
                {text === 'admin/billing' && (
                  <>
                    <ListItemIcon className={icons}>
                      <AttachMoneyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Billing</ListItemText>
                  </>
                )}
               {text === 'admin/vendors' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ContactPhoneOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Vendors</ListItemText>
                  </>
                )}
                {text === 'admin/pto-request-review' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      PTO Request Review
                    </ListItemText>
                  </>
                )}             
              </ListItem>
            </Link>
          ))}
        <ListItem  onClick={handleClick}>
        <ListItemIcon className={icons}>
          <InboxIcon />
        </ListItemIcon>
        <ListItemText className={sideNavText} primary="Reports" />
        {openPanel ? <ExpandLess className={sideNavText}/> : <ExpandMore className={sideNavText}/>}
      </ListItem>
      <Collapse in={openPanel} timeout="auto" unmountOnExit>
          {[ 'admin/billingReport',
            'admin/pto-request-report',
            'admin/invoice-reports',
            'admin/task-report'
          ].map(text => (
            <Link className={sideNavLink} to={`/${text}`}>
              <List component="div" disablePadding>
              <ListItem button key={text} >
                {text === 'admin/billingReport' && (
                  <>
                    <ListItemIcon className={icons}>
                      <LocalAtmOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Billing Report</ListItemText>
                  </>
                )}
                 {text === 'admin/pto-request-report' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      PTO Request Report
                    </ListItemText>
                  </>
                )}
                {text === 'admin/invoice-reports' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      Invoice Reports
                    </ListItemText>
                  </>
                )}{
                  text === 'admin/task-report' && (
                    <>
                       <ListItemIcon className={icons}>
                        <EventNoteIcon />
                      </ListItemIcon>
                      <ListItemText className={sideNavText}>
                        Task Report
                      </ListItemText>
                    </>
                  )
                }
              </ListItem>
              </List>
            </Link>
          ))}
          </Collapse>
        </List>
      </>
    );
  };

  const renderManagerList = () => {
    return (
      <>
        {open ? <h4 className={subHeader}>MANAGER</h4> : null}
        <List>
          {[
            'admin/approvals',
            'admin/summaries',
            'admin/summariesbyday',
            'admin/defaulters',
            'admin/pto-request-review',
            'admin/pto-request-report',
            'admin/users',
            'admin/externalUsers',
          ].map(text => (
            <Link className={sideNavLink} to={`/${text}`}>
              <ListItem button key={text}>
                {text === 'admin/approvals' && (
                  <>
                    <ListItemIcon className={icons}>
                      <PlaylistAddCheckOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Approvals</ListItemText>
                  </>
                )}
                {text === 'admin/summaries' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries</ListItemText>
                  </>
                )}
                {text === 'admin/summariesbyday' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries By Day</ListItemText>
                  </>
                )}
                {text === 'admin/users' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Users</ListItemText>
                  </>
                )}
                 {text === 'admin/externalUsers' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>External Users</ListItemText>
                  </>
                )}
                {text === 'admin/defaulters' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventBusyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Defaulters</ListItemText>
                  </>
                )}
                {text === 'admin/pto-request-review' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      Pto Request Review
                    </ListItemText>
                  </>
                )}
                 {text === 'admin/pto-request-report' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      Pto Request Report
                    </ListItemText>
                  </>
                )}
              </ListItem>
            </Link>
          ))}
        </List>
      </>
    );
  };

  const renderClMgList = () => {
    return (
      <>
        {open ? <h4 className={subHeader}>Client Manager</h4> : null}
        <List>
          {[
            'admin/approvals',
          ].map(text => (
            <Link className={sideNavLink} to={`/${text}`}>
              <ListItem button key={text}>
                {text === 'admin/approvals' && (
                  <>
                    <ListItemIcon className={icons}>
                      <PlaylistAddCheckOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Approvals</ListItemText>
                  </>
                )}
              </ListItem>
            </Link>
          ))}
        </List>
      </>
    );
  };
  const renderHrList = () => {
    return (
      <>
        {open ? <h4 className={subHeader}>HR</h4> : null}
        <List>
          {[
            'admin/approvals',
            'admin/summaries',
            'admin/summariesbyday',
            'admin/defaulters',
            'admin/users',
            'admin/externalUsers',
            'admin/vacationHoursList',
            'admin/vendors',
            'admin/pto-request-review',
            'admin/pto-request-report',
          ].map(text => (
            <Link className={sideNavLink} to={`/${text}`}>
              <ListItem button key={text}>
                {text === 'admin/approvals' && (
                  <>
                    <ListItemIcon className={icons}>
                      <PlaylistAddCheckOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Approvals</ListItemText>
                  </>
                )}
                {text === 'admin/summaries' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries</ListItemText>
                  </>
                )}
                {text === 'admin/summariesbyday' && (
                  <>
                    <ListItemIcon className={icons}>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Summaries By Day</ListItemText>
                  </>
                )}
                {text === 'admin/defaulters' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventBusyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Defaulters</ListItemText>
                  </>
                )}
                {text === 'admin/users' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Users</ListItemText>
                  </>
                )}
                  {text === 'admin/externalUsers' && (
                  <>
                    <ListItemIcon className={icons}>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>External Users</ListItemText>
                  </>
                )}
                {text === 'admin/vacationHoursList' && (
                  <>
                    <ListItemIcon className={icons}>
                      <Filter7OutlinedIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Vacation Hours</ListItemText>
                  </>
                )}
                {text === 'admin/vendors' && (
                  <>
                    <ListItemIcon className={icons}>
                      <WatchLaterIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>Vendors</ListItemText>
                  </>
                )}
                {text === 'admin/pto-request-review' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      Pto Request Review
                    </ListItemText>
                  </>
                )}
                 {text === 'admin/pto-request-report' && (
                  <>
                    <ListItemIcon className={icons}>
                      <EventNoteIcon />
                    </ListItemIcon>
                    <ListItemText className={sideNavText}>
                      Pto Request Report
                    </ListItemText>
                  </>
                )}
              </ListItem>
            </Link>
          ))}
        </List>
      </>
    );
  };
  const renderSideNavList = () => {
    if (user.role === 'admin') {
      return renderAdminList();
    }
    if (user.role === 'manager') {
      return renderManagerList();
    }
    if (user.role === 'hr') {
      return renderHrList();
    }
    if (user.role === 'user') {
      return null;
    }
    if (user.role === 'clientManager') {
      return renderClMgList();
    }
  };

  const approvalsRoles = ['admin', 'manager', 'hr','clientManager'];
  const summariesRoles = ['admin', 'manager', 'hr'];
  const summariesByDayRoles = ['admin', 'manager', 'hr'];
  const defaulterRoles = ['admin', 'manager', 'hr'];
  const usersRoles = ['admin', 'hr', 'manager'];
  const vacationHoursRoles = ['admin', 'hr'];
  const projectsRoles = ['admin'];
  const billingRoles = ['admin'];
  const billingReportRoles = ['admin'];
  const vendorsRoles = ['admin', 'hr'];
  const profileRoles = ['admin', 'user', 'manager', 'hr'];
  const timesheetRoles = ['admin', 'user', 'manager', 'hr'];
  const reportsRoles = ['admin', 'user', 'manager', 'hr'];
  const ptoRequestRoles = ['admin', 'user', 'manager', 'hr'];
  const ptoRequestsReviewRoles = ['admin', 'manager'];

  return (
    <div className={root}>
      <CssBaseline />
      <AppBar
        position='fixed'
        className={clsx(appBar, {
          [appBarShift]: open,
        })}
      >
        <Toolbar className={header}>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            className={clsx(menuButton, {
              [hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
         <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <InputLabel style={{ display: 'flex' }}>
              <p
                style={{
                  fontWeight: 'bolder',
                  color: 'white',
                }}
              >
                {user.firstName} {user.lastName}
              </p>
            </InputLabel>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Button
                  variant='contained'
                  onClick={handleLogout}
                  className={logoutButton}
                >
                  <b>Logout</b>
                  <AccountCircleIcon style={{ marginLeft: '8px' }} />
                  <Link to='/' style={{ textDecoration: 'none' }}></Link>
                </Button>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        style={{ backgroundColor: '#fafafa' }}
        variant='permanent'
        className={clsx(drawer, {
          [drawerOpen]: open,
          [drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [drawerOpen]: open,
            [drawerClose]: !open,
          }),
        }}
      >
        <div className={toolbar}>
          <IconButton onClick={handleDrawerClose} className={closeIcon}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <div>
          {open ? (
            <img alt='techmileage-logo' width='80%' height='auto' src={logo} />
          ) : null}
        </div>
        <Divider className={divider} />
       {user.role === 'clientManager'?null:<List>
          {['profile', 'reports', 'timesheet', 'pto-request'].map((text, index) => (
            <Link className={sideNavLink} to={`/${text}`}>
              <ListItem button key={text}>
                <ListItemIcon className={icons}>
                  {index === 0 && <AccountBoxOutlinedIcon />}
                  {index === 1 && <AssignmentOutlinedIcon />}
                  {index === 2 && <AccessTimeIcon />}
                  {index === 3 && <EventNoteIcon />}
                </ListItemIcon>
                {text === 'profile' && (
                  <ListItemText className={sideNavText}>Profile</ListItemText>
                )}
                {text === 'reports' && (
                  <ListItemText className={sideNavText}>Reports</ListItemText>
                )}
                {text === 'timesheet' && (
                  <ListItemText className={sideNavText}>Timesheet</ListItemText>
                )}
                {text === 'pto-request' && (
                  <ListItemText className={sideNavText}>PTO Request</ListItemText>
                )}
              </ListItem>
            </Link>
          ))}
        </List>}
        <Divider className={divider} />
        {renderSideNavList()}
      </Drawer>
      <main className={content}>
        <div className={toolbar}>
          <Container>
            <PrivateRoute
              path='/timesheet'
              roles={timesheetRoles}
              component={Timesheet}
            />
            <PrivateRoute path='/reports' roles={reportsRoles} component={UserReports} />
            <PrivateRoute path='/profile' roles={profileRoles} component={ProfilePage} />
            <PrivateRoute
              path='/admin/approvals'
              roles={approvalsRoles}
              component={TimesheetApproval}
            />
            <PrivateRoute
              path='/admin/summaries'
              roles={summariesRoles}
              component={TimesheetSummary}
            />
            <PrivateRoute
              path='/admin/summariesbyday'
              roles={summariesByDayRoles}
              component={SummaryByDay}
            />
            <PrivateRoute
              path='/admin/defaulters'
              roles={defaulterRoles}
              component={TimesheetDefaulters}
            />
            <PrivateRoute
              path='/admin/users'
              roles={usersRoles}
              component={TimesheetUsers}
            />
             <PrivateRoute
              path='/admin/externalUsers'
              roles={usersRoles}
              component={TimesheetExternalUsers}
            />
            <PrivateRoute
              path='/admin/uploadVacationHrs'
              roles={vacationHoursRoles}
              component={TimesheetVacationHours}
            />
            <PrivateRoute
              path='/admin/vacationHoursList'
              roles={vacationHoursRoles}
              component={VacationHours}
            />
            <PrivateRoute
              path='/admin/userdetails/:uid?'
              roles={vacationHoursRoles}
              component={TimesheetUserDetails}
            />
            <PrivateRoute
              path='/admin/externaldetails/:uid?'
              roles={vacationHoursRoles}
              component={TimesheetExternalUserDetails}
            />
            <PrivateRoute
              path='/admin/projects'
              roles={projectsRoles}
              component={ProjectsManage}
            />
            <PrivateRoute
              path='/admin/projectdetails/:pid?'
              roles={projectsRoles}
              component={ProjectDetails}
            />
            <PrivateRoute
              path='/admin/billing'
              roles={billingRoles}
              component={Billing}
            />
            <PrivateRoute
              path='/admin/billingReport'
              roles={billingReportRoles}
              component={BillingReport}
            />
            <PrivateRoute
              path='/admin/vendors'
              roles={vendorsRoles}
              component={VendorReport}
            />
            <PrivateRoute
              path='/admin/vendordetails/:vid?'
              roles={vendorsRoles}
              component={VendorDetails}
            />
            <PrivateRoute
              path='/pto-request'
              roles={ptoRequestRoles}
              component={PtoRequest}
            />
            <PrivateRoute
              path='/admin/pto-request-review'
              roles={ptoRequestsReviewRoles}
              component={PtoRequestReview}
            />
            <PrivateRoute
              path='/admin/pto-request-report'
              roles={ptoRequestsReviewRoles}
              component={PtoRequestReport}
            />
            <PrivateRoute
              path='/admin/invoice-reports'
              roles={ptoRequestsReviewRoles}
              component={invoiceReport}
            />
            <PrivateRoute
            path='/admin/task-report'
            roles={ptoRequestsReviewRoles}
            component={TaskReport}
          />
            <Route path='/unauthorized' component={UnauthPage} />
          </Container>
        </div>
      </main>
    </div>
  );
};
export default SideNav;
